import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = () => ({
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  flex: {
    flex: 1,
  },
});

const KobooToolbar = props =>
  <AppBar position="static">
    <Toolbar>
      <IconButton
        className={props.classes.menuButton}
        color="inherit"
        aria-label="Menu"
        onClick={props.openDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
      <Typography variant="h6" color="inherit" className={props.classes.flex}>
        Koboo
      </Typography>
    </Toolbar>
  </AppBar>;

KobooToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  openDrawer: PropTypes.func,
};

export default withStyles(styles)(KobooToolbar);



// WEBPACK FOOTER //
// ./src/components/Layout/KobooToolbar.jsx